import { FC, useState } from "react";
import {
  ConditionIcon,
  ParticipantsTable,
  WinnersTable,
} from "entities/wheel-raffle";
import { Tabs } from "shared/ui";
import type { TabItem } from "shared/ui";
import {
  useParticipantsPage,
  useWinnersPage,
} from "../../model/useRafflePeoplePage";
import { PeopleSection } from "./PeopleSection";

import styles from "./RaffleDetailPage.module.css";

type PeopleTab = "participants" | "winners";

interface Props {
  raffleId: number;
  isDrawn: boolean;
  participantsCount: number;
}

// До розыгрыша вкладка победителей не нужна: бэк отвечает 409.
const getTabs = (
  isDrawn: boolean,
  participants: number,
  winners: number,
): TabItem<PeopleTab>[] => {
  const participantsTab: TabItem<PeopleTab> = {
    value: "participants",
    label: `Participants (${participants})`,
    icon: <ConditionIcon name="people" size={20} />,
  };
  if (!isDrawn) return [participantsTab];
  const winnersTab: TabItem<PeopleTab> = {
    value: "winners",
    label: `Winners (${winners})`,
    icon: <ConditionIcon name="trophy" size={20} />,
  };
  return [winnersTab, participantsTab];
};

export const RafflePeople: FC<Props> = ({
  raffleId,
  isDrawn,
  participantsCount,
}) => {
  // После розыгрыша важнее победители — открываем их первыми.
  const [tab, setTab] = useState<PeopleTab>(
    isDrawn ? "winners" : "participants",
  );
  const participants = useParticipantsPage(raffleId, isDrawn);
  const winners = useWinnersPage(raffleId, isDrawn);

  return (
    <>
      <Tabs
        items={getTabs(isDrawn, participantsCount, winners.total)}
        active={tab}
        onChange={setTab}
        tabClassName={styles.pill}
        activeClassName={styles.pillActive}
      />
      {tab === "winners" ? (
        <PeopleSection
          state={winners}
          emptyText="No winners"
          renderTable={(items, offset) => (
            <WinnersTable winners={items} offset={offset} />
          )}
        />
      ) : (
        <PeopleSection
          state={participants}
          emptyText="No participants yet"
          renderTable={(items, offset) => (
            <ParticipantsTable participants={items} offset={offset} />
          )}
        />
      )}
    </>
  );
};
